import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// v-calendar 3.0.0-alpha.8 - Use SetupCalendar (PascalCase) for this version
// Try standard import first - this version may work better with Vue 3.2
import { SetupCalendar } from 'v-calendar'
import 'v-calendar/dist/style.css'

const app = createApp(App)
app.use(router)
app.use(SetupCalendar, {})
app.mount('#app')
app.config.errorHandler = (err) => {
  console.log(err)
}
